export function getCookie(key: string) {
    if (typeof document === 'undefined') return ''
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
}

export function setCookie(key: string, value: string, daysToExpire?: number) {
    if (typeof document === 'undefined') return

    let cookieString = `${key}=${value}; path=/`

    if (daysToExpire) {
        const expDate = new Date()
        expDate.setDate(expDate.getDate() + daysToExpire)
        cookieString += `; expires=${expDate.toUTCString()}`
    }

    document.cookie = cookieString
}

export function setCrossDomainCookie(key: string, value: string, daysToExpire = 30) {
    if (typeof document === 'undefined') return;

    const expDate = new Date();
    expDate.setDate(expDate.getDate() + daysToExpire);
    
    // Use .reassurez-moi.fr as the domain to share across subdomains
    const domain = '.reassurez-moi.fr';
    
    document.cookie = `${key}=${value}; expires=${expDate.toUTCString()}; path=/; domain=${domain}; SameSite=None; Secure`;
}

export function removeCookie(key: string) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
